/**
 * Cliente tipado para el endpoint /health del módulo Go _health.
 *
 * El tipo `HealthReport` espeja la forma documentada en
 * `specs/001-crear-estructura-base/contracts/health-endpoint.md`.
 * Cualquier cambio en el contrato debe propagarse aquí en el mismo PR.
 */
import { apiBase } from "../env";

export type HealthStatus = "ok" | "degraded" | "fatal";
export type CheckOutcome = "ok" | "error";

export interface HealthReport {
  status: HealthStatus;
  version: string;
  checks: {
    database: CheckOutcome;
    sentry: CheckOutcome;
  };
  timestamp: string; // ISO8601 UTC
}

/**
 * Trae el reporte de health del backend. Lanza si la respuesta no
 * es 2xx (TanStack Query consumirá el error como `isError = true` y
 * lo capturará el ErrorBoundary global).
 *
 * No loguea — los errores se reportan a Sentry vía el caller.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<HealthReport> {
  const init: RequestInit = signal ? { signal } : {};
  // B7-06: usar el apiBase canónico por-env (antes VITE_API_BASE_URL, que no
  // existe en ningún entorno → siempre caía a "").
  const res = await fetch(`${apiBase()}/health`, init);
  if (!res.ok) {
    throw new Error(`fetchHealth: HTTP ${res.status}`);
  }
  return (await res.json()) as HealthReport;
}
